module.exports = __webpack_public_path__ + "static/product-bg-114efd8ce5f843234ba38a794dc2db8c.jpg";